import type { Route } from 'next';
import Link from 'next/link';
import wChanceNothing from '../../../../assets/images/wchance/wchance_nothing.png';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import WChanceStaging from '../../../../components/ui/WChanceStaging/WChanceStaging';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { isVersion } from '../../../../utils/version';
import type { WChanceDrawResultGoodsItem } from '../../types';
import styles from './WChanceResultMulti.module.scss';

export type WChanceResultMultiProps = {
  wChanceResults: Array<WChanceDrawResultGoodsItem>;
  version?: string | null;
};

function WChanceResultMulti({ wChanceResults, version }: WChanceResultMultiProps) {
  const isNothing = (item: WChanceDrawResultGoodsItem) => {
    // ハズレ
    return !item.goodsId;
  };
  return (
    <ul className={styles.componentStyle}>
      {wChanceResults.map((result, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <li key={index}>{isNothing(result) ? nothingImage() : goodsImage(result, version, result.cutoffId)}</li>
      ))}
      {/* ダミー */}
      {dummy()}
    </ul>
  );
}

// ハズレ
function nothingImage() {
  return (
    <div className={styles.itemLink}>
      <div className={styles.imageWrapper}>
        <div className={styles.itemImage}>
          <ImageView src={wChanceNothing.src} />
        </div>
      </div>
    </div>
  );
}

// 当選
function goodsImage(item: WChanceDrawResultGoodsItem, version?: string | null, cutoffId?: number | null) {
  const getHref = (): string => {
    if (isVersion(version, '2.0')) {
      return `/account/collection/${item.goodsId}?cutoffId=${cutoffId ?? ''}`;
    }
    return `/account/collection/${item.goodsId}`;
  };

  return (
    <Link className={styles.itemLink} href={getHref() as Route}>
      <div className={styles.imageWrapper}>
        <div className={styles.itemImage}>
          <ImageView src={item.imageUrl} />
        </div>
        <div className={styles.rankWrapper}>
          <WChanceStaging size={'small'} />
        </div>
      </div>
      <div className={`${styles.itemName} ${utilsStyles.textBold}`}>{item.goodsName}</div>
    </Link>
  );
}

function dummy() {
  const dummy = [];
  for (let i = 0; i < 4; i++) {
    dummy.push(<li key={`dummy_${i}`} />);
  }
  return dummy;
}

export default WChanceResultMulti;
